import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment } from '@material-ui/icons';

//tabla y card components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

//servicios
import { wsGet } from 'services/WService.js';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Cód. Proveedor', accessor: 'CardCode', width: 140, align: 'center' },
  { Header: 'Nombre Proveedor', accessor: 'CardName' },
  { Header: 'RUC / DNI', accessor: 'LicTradNum', width: 140, align: 'center' },
  { Header: 'Dirección', accessor: 'Street' },
  { Header: 'Tipo', accessor: 'AdresType', width: 120, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

export default function PCustomerDetail() {
  const classes = useStyles();
  const { id } = useParams();

  const [pCustomer, setPCustomer] = useState({ customers: [] });

  async function getProviderCustomer() {
    let response = await wsGet('prom/provider-business-line', id);
    if (response.success) setPCustomer(response.data);
  }

  useEffect(() => {
    getProviderCustomer();
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          <b>Clientes del proveedor: </b>
          {pCustomer.CardCode} - {pCustomer.CardName}
          <b> Giro: </b> {pCustomer.code} - {pCustomer.description}
        </h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          excelName="Proveedor-cliente"
          defaultWidth={1200}
          formatDate="DD-MM-YYYY"
          columns={columns}
          data={pCustomer.customers.map((item, i) => {
            return {
              num: i + 1,
              CardCode: item.CardCode,
              CardName: item.CardName,
              LicTradNum: item.LicTradNum,
              Street: item.Street,
              AdresType: item.AdresType === 'B' ? 'Fiscal' : 'Entrega',
              actions: '',
            };
          })}
        />
      </CardBody>
    </Card>
  );
}
